import { Component, OnInit } from '@angular/core';
import { ServiceMangeService } from 'src/app/services/service-mange.service';
import { AddUtiltyComponent } from '../add-utilty/add-utilty.component';
import { MatDialog } from '@angular/material/dialog';
import { MainService } from 'src/app/services/main.service';
import { AddSectionComponent } from '../add-section/add-section.component';
import { AddInoviceComponent } from '../add-inovice/add-inovice.component';

@Component({
  selector: 'app-all-utiltes',
  templateUrl: './all-utiltes.component.html',
  styleUrls: ['./all-utiltes.component.css']
})
export class AllUtiltesComponent implements OnInit {

  allUitlty:any = []
  uiltyDetails:any = {
    unit_measure : "",
    sections : []
  }
  constructor(private rest : ServiceMangeService ,
    private mainServ : MainService,
      public dialog: MatDialog,){}

  ngOnInit(){
    this.getData()
  }

  getData(){
    this.rest.retirve_all_utilties().subscribe((res:any) => {
      console.log(res)
      this.allUitlty = res
      this.allUitlty.forEach((element:any) => {
        element.status = false
      });
      
      this.uiltyDetails = res[0]
      this.allUitlty[0].status = true
    })
  }

  uilty_details(item:any){
    this.allUitlty.forEach((element: any) => {
      if (element.id == item.id) {
        element.status = true
      } else {
        element.status = false
      }
    });
    this.uiltyDetails = item
  }

  addUilty(item?:any){
    let data;
    if(item){
      data = item
    }
    const dialogRef = this.dialog.open(AddUtiltyComponent, {
      width: '450px',
      data : data
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        if(!item){
          if(result.status == true){
            this.rest.disabledUtlity(result.utility_id).subscribe((res:any) => {
              console.log(res)
            })
          }
          this.rest.addUtitlyImage(result).then(response => response.text())
          .then((res: any) => {
            console.log(res)
            this.mainServ.erorrToast("Utility Added")
          })
          console.log(result)
        }else {
          console.log(result)
          if(result.status){
            let disabledData = {
              id : result.utility_id,
              disabled :result.status
            }
            this.rest.disabledUtlity(disabledData).subscribe((res:any) => {
              console.log(res)
            })
          }
          this.rest.editUtility(result).subscribe((res:any) => {
            console.log(res)
            this.mainServ.SuccessToast("Utility Edited")
            this.getData()
          })
        
        }

      }
    });
  }

  addSection(value:any , status :any){
    let data;
    if(status == 'edit'){
      data = value
    }
    console.log(value)
    const dialogRef = this.dialog.open(AddSectionComponent, {
      width: '450px',
      data : data
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {

        if(status == 'edit'){
          this.rest.editSection(result).subscribe((res:any) => {
            console.log(res)
            this.mainServ.SuccessToast("Section Edited")
            this.getData()
          })
        }else {
          result.utility_id = value.id
          this.rest.addSection(result).subscribe((res:any) => {
            console.log(res)
            this.mainServ.SuccessToast("Section added")
            this.getData()
          })
        }      
      }
    });
  }

  addInvoce(){
    const dialogRef = this.dialog.open(AddInoviceComponent, {
      width: '450px',
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if(result){
        result.utility_id =  this.uiltyDetails.id
        console.log(result)
        this.rest.addInvoce(result).subscribe((res:any) => {
          console.log(res)
          this.mainServ.SuccessToast("Utility Invoice Added")
        },((err:any) => {
          this.mainServ.erorrToast(err.error.message)
        }))
      }
    })
  }


}
